// src/components/ConfirmModal.tsx

import { useState } from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  confirmButtonClass?: string;
  isLoading?: boolean;
  loadingText?: string;
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Remove",
  isLoading = false,
  loadingText,
}: ConfirmModalProps) {
  const [confirmHov,  setConfirmHov]  = useState(false);
  const [confirmPress, setConfirmPress] = useState(false);
  const [cancelHov,   setCancelHov]   = useState(false);
  const [cancelPress,  setCancelPress]  = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div
        className="max-w-md w-full p-6 space-y-4"
        style={{
          background: "#FFFFFF",
          border: "3px solid #1A1A1A",
          borderRadius: 20,
          boxShadow: "6px 6px 0px #1A1A1A",
        }}
      >
        <h3
          className="text-lg text-gray-900"
          style={{ fontFamily: "'Fredoka', sans-serif", fontWeight: 700 }}
        >
          {title}
        </h3>
        <p
          className="text-base pb-1 text-gray-600"
          style={{ fontFamily: "'Nunito', sans-serif" }}
        >
          {message}
        </p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={isLoading}
            onMouseEnter={() => setCancelHov(true)}
            onMouseLeave={() => { setCancelHov(false); setCancelPress(false); }}
            onMouseDown={() => setCancelPress(true)}
            onMouseUp={() => setCancelPress(false)}
            style={{
              fontFamily: "'Fredoka', sans-serif",
              fontWeight: 600,
              fontSize: 16,
              background: cancelPress ? "rgba(0,0,0,0.12)" : cancelHov ? "rgba(0,0,0,0.06)" : "#FFFFFF",
              color: "#1A1A1A",
              border: "3px solid #1A1A1A",
              borderRadius: 100,
              boxShadow: "4px 4px 0px #1A1A1A",
              padding: "8px 20px",
              cursor: isLoading ? "default" : "pointer",
              opacity: isLoading ? 0.65 : 1,
              transform: cancelPress ? "scale(0.97)" : "scale(1)",
              transition: "all 0.1s ease",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            onMouseEnter={() => !isLoading && setConfirmHov(true)}
            onMouseLeave={() => { setConfirmHov(false); setConfirmPress(false); }}
            onMouseDown={() => !isLoading && setConfirmPress(true)}
            onMouseUp={() => setConfirmPress(false)}
            style={{
              fontFamily: "'Fredoka', sans-serif",
              fontWeight: 700,
              fontSize: 16,
              background: (!isLoading && confirmPress) ? "#B34428" : (!isLoading && confirmHov) ? "#C94E30" : "#E05A3A",
              color: "#FFFFFF",
              border: "3px solid #1A1A1A",
              borderRadius: 100,
              boxShadow: "4px 4px 0px #1A1A1A",
              padding: "8px 20px",
              cursor: isLoading ? "default" : "pointer",
              opacity: isLoading ? 0.65 : 1,
              transform: (!isLoading && confirmPress) ? "scale(0.97)" : "scale(1)",
              transition: "all 0.1s ease",
            }}
          >
            {isLoading ? (loadingText ?? "Removing...") : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}